// '/': the public home page (features/site/home). A signed-in chef goes
// straight to the app (their gate first, if one is open); anonymous
// visitors get the home page inside the site's frame (routes/_site.tsx).
// Its own chunk (router autoCodeSplitting), and the hero film is a further
// chunk behind that (features/site/film/HeroFilm.tsx).
//
// A session check that fails (the API down mid-deploy, a 502 from the
// tunnel, a lost connection) counts as a visitor: the home page still
// shows. It is asked once, with no retries, so an API that is down never
// holds a blank page for the global retries' three seconds.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { HomePage } from '@/features/site/home/HomePage';
import { gateRoute, sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/_site/')({
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData({ ...sessionQuery, retry: false }).catch(() => null);
    if (s?.authenticated) throw redirect({ to: gateRoute(s) ?? '/dashboard' });
  },
  component: HomePage,
});
